import storage from '/src/utils/storage';

export const getStorageParam = (key) => storage('local').get(`${storage('session').id}_${key}`) ?? {};

export const removeStorageParam = (key) => storage('local').remove(`${storage('session').id}_${key}`);

export const setStorageParam = (key, value = {}) => storage('local').set(`${storage('session').id}_${key}`, value);